import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=6c62974b&scoped=true&"
import script from "./InfoBanner.vue?vue&type=script&lang=ts&"
export * from "./InfoBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c62974b",
  null
  
)

export default component.exports